import { z } from 'zod';

import { BorrowerId, WorkoutPlanId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateRepaymentPlanOfferNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
  borrowerIds: z.array(zodBrandedUuid<BorrowerId>()),
});

export const GenerateRepaymentPlanOfferNoticeSideEffect = GenerateRepaymentPlanOfferNoticeSideEffectContext.extend({
  type: z.literal('generateRepaymentPlanOfferNotice'),
});
export type GenerateRepaymentPlanOfferNoticeSideEffect = z.infer<typeof GenerateRepaymentPlanOfferNoticeSideEffect>;
